import { lang } from '@umu/ukit-lang';
import { ITemplatePanelTypeMapInfo, PanelType } from '../../interface/multiCapabilityTemplate';
import { templateList } from './templateList';
import { templateAdd } from './templateAdd';
import { templateEditor } from './templateEditor';
import { templatePreview } from './templatePreview';
import { templateCapabilitySelect } from './templateCapabilitySelect';

export const panelTypeMapInfo: ITemplatePanelTypeMapInfo = {
    [PanelType.LIST]: {
        title: lang('设置多维度评价'),
        pageComponent: templateList,
    },
    [PanelType.ADD]: {
        title: lang('新建评价标准_Set_new_scorecard_criteria'),
        pageComponent: templateAdd,
    },
    [PanelType.EDIT]: {
        title: lang('编辑评价标准'),
        pageComponent: templateEditor,
    },
    [PanelType.PREVIEW]: {
        title: lang('查看评价标准'),
        pageComponent: templatePreview,
    },
    [PanelType.SELECT_CAPABILITY_DETAIL]: {
        title: lang('设置多维度评价-选择评价维度'),
        pageComponent: templateCapabilitySelect,
    },
};
